import MessageCenterGrid from './MessageCenterGrid';

export default MessageCenterGrid;



// WEBPACK FOOTER //
// ./src/components/grids/MessageCenterGrid/index.jsx